import React from 'react';

import { ChipPlain, ISelect } from '@treelab/panda';

import { Container } from './styled';

interface IProps {
  className?: string;
  items: ISelect[] | null;
}

const SelectList: React.FC<IProps> = ({ className, items }) => (
  <Container className={className}>
    {(items || []).map((item: ISelect, index: number) => (
      <ChipPlain
        key={`${item.name}-${index}`}
        color={item.color}
        css={`
          margin-right: 4px;
          margin-bottom: 4px;
        `}
      >
        {item.name}
      </ChipPlain>
    ))}
  </Container>
);

export default SelectList;
